import { useParams, useNavigate, Outlet } from 'react-router-dom';
import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { type UserDetails as UserDetailsType } from '../../../schemas/API/GET/users/response';
import { useState, useEffect } from 'react';
import { SectionHeader } from '@/components/Section/SectionHeader';
import { Stack } from '@mantine/core';

export const UserLayout = (): JSX.Element => {
  const { userId } = useParams<{ userId: string }>();

  const { data: user } = useSWR<UserDetailsType>(
    `/users/${userId}`,
    getFetcher
  );

  const [fullname, setFullname] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!user) return;
    setFullname(`${user.info.firstName} ${user.info.lastName}`);
  }, [user]);

  const navigate = useNavigate();
  const handleClose = (): void => navigate('/users');

  return (
    <Stack className="h-full p-8 overflow-auto">
      <SectionHeader
        header={fullname}
        onClose={handleClose}
        showServiceSelector={false}
      />
      <Outlet />
    </Stack>
  );
};
